import { render } from "./LabeledTooltip.vue?vue&type=template&id=2e893305&scoped=true&ts=true"
import script from "./LabeledTooltip.vue?vue&type=script&lang=ts"
export * from "./LabeledTooltip.vue?vue&type=script&lang=ts"

import "./LabeledTooltip.vue?vue&type=style&index=0&id=2e893305&lang=scss&scoped=true"

import exportComponent from "../../../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e893305"]])

export default __exports__